var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapa13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_822_1711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9501 41.0728L47.0028 36.9412C47.908 36.3251 48.1659 35.1046 47.5874 34.1748C47.0075 33.243 45.7948 32.9364 44.8418 33.4807L34.5724 39.7243L25.5937 37.1855L32.3502 34.3453C33.5247 33.8476 34.1051 32.5184 33.6717 31.3186C33.2132 30.0497 31.7997 29.4075 30.5425 29.8968L25.7792 31.7505C19.5165 27.9075 15.3274 32.6714 15.3274 32.6714H12.5225",
    stroke: "#102E7A",
    strokeWidth: 1.40818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5225 44.8934H17.5804L34.9818 46.7709L40.8434 41.9778",
    stroke: "#102E7A",
    strokeWidth: 1.40818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4804 35.5242L42.0492 33.7018C42.4659 32.6892 42.0095 31.5282 41.0148 31.0704C40.0178 30.6116 38.8364 31.023 38.3403 32.002L34.7358 39.6247",
    stroke: "#102E7A",
    strokeWidth: 1.40818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5224 38.0729V47.2789H1.30396V30.3808H12.5224V36.6706",
    stroke: "#102E7A",
    strokeWidth: 1.40818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91311 43.7233C8.00839 43.7233 8.89629 42.8354 8.89629 41.7401C8.89629 40.6448 8.00839 39.7569 6.91311 39.7569C5.81783 39.7569 4.92993 40.6448 4.92993 41.7401C4.92993 42.8354 5.81783 43.7233 6.91311 43.7233Z",
    stroke: "#102E7A",
    strokeWidth: 1.40818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8368 19.8665H27.449V23.2148H36.8368V19.8665Z",
    stroke: "#102E7A",
    strokeWidth: 1.40818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9594 23.2148H29.3267V26.787H34.9594V23.2148Z",
    stroke: "#102E7A",
    strokeWidth: 1.40818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3012 13.2273C40.7861 12.1281 41.0555 10.9123 41.0555 9.63363C41.0555 4.71131 37.0652 0.721008 32.1428 0.721008C27.2205 0.721008 23.2302 4.71131 23.2302 9.63363C23.2302 12.8358 24.9193 15.6431 27.4548 17.2143V19.8664H36.8309V17.2143C37.9582 16.5157 38.9182 15.5726 39.6369 14.4592",
    stroke: "#102E7A",
    strokeWidth: 1.40818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4932 8.20551L31.5102 12.1884L28.7927 9.47089",
    stroke: "#102E7A",
    strokeWidth: 1.40818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4081 9.92114H16.1953",
    stroke: "#102E7A",
    strokeWidth: 1.40818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8425 15.8256L18.1941 17.9319",
    stroke: "#102E7A",
    strokeWidth: 1.40818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1677 16.3032L45.8161 18.4096",
    stroke: "#102E7A",
    strokeWidth: 1.40818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8777 10.4727H48.0905",
    stroke: "#102E7A",
    strokeWidth: 1.40818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4436 4.56842L46.092 2.46198",
    stroke: "#102E7A",
    strokeWidth: 1.40818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1184 4.09076L18.47 1.98431",
    stroke: "#102E7A",
    strokeWidth: 1.40818,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_822_1711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.599854)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapa13);
export default __webpack_public_path__ + "static/media/Capa_1 (3).8f2d4208c41219606df298c09bcf151c.svg";
export { ForwardRef as ReactComponent };